import { scrollToId } from "@/lib/api";

export const Footer = () => {
  return (
    <footer className="border-t border-espresso/10 bg-sand px-6 py-16 sm:px-10">
      <div className="mx-auto max-w-[1400px]">
        <button
          data-testid="footer-cta"
          onClick={() => scrollToId("waitlist")}
          className="block text-left font-display text-[13vw] font-light leading-[0.85] tracking-tighter text-espresso transition-colors duration-500 hover:text-terracotta sm:text-[9vw]"
        >
          Rise to it.
        </button>

        <div className="mt-16 flex flex-col justify-between gap-8 border-t border-espresso/10 pt-8 md:flex-row md:items-center">
          <div>
            <img
              src={`${process.env.PUBLIC_URL}/brand-mark.png`}
              alt="The Upper Room"
              className="mb-4 h-14 w-auto"
            />
            <p className="font-display text-xl font-medium tracking-tight text-espresso">
              The Upper Room
            </p>
            <p className="mt-1 font-body text-sm font-light text-stone">
              Specialty co-working · Horizon Square, Johor
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-8">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram"
              className="link-underline font-body text-xs font-semibold uppercase tracking-[0.2em] text-stone transition-colors duration-300 hover:text-espresso"
            >
              Instagram
            </a>
            <a
              href="mailto:hello@theupperroom.my"
              data-testid="footer-email"
              className="link-underline font-body text-xs font-semibold uppercase tracking-[0.2em] text-stone transition-colors duration-300 hover:text-espresso"
            >
              hello@theupperroom.my
            </a>
            <span className="font-body text-xs font-light text-stone/70">
              Coffee by <span className="font-semibold text-espresso">The 18 Coffee Roasters</span>
            </span>
          </div>
        </div>

        <p className="mt-10 font-body text-xs font-light text-stone/60">
          © {new Date().getFullYear()} The Upper Room. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
